import React from 'react'
// import { ThemeToggler } from '@skagami/gatsby-plugin-dark-mode'
import styles from './Sidebar.module.scss';

// const  SiteThemeToggler = () => {
//     return (
//       <ThemeToggler>
//         {({ theme, toggleTheme }) => (
//           <label className={styles['dayNight']}>
//             <input
//               type="checkbox"
//               onChange={e => toggleTheme(!e.target.checked ? 'light' : 'dark')}
//               checked={theme === 'dark'}
//             />
//             <div></div>
//           </label>
//         )}
//       </ThemeToggler>
//     )
// }

import { useTheme } from '@skagami/gatsby-plugin-dark-mode'

const SiteThemeToggler = () => {
  const [theme, toggleTheme] = useTheme()

  // Don't render anything at compile time. Deferring rendering until we
  // know which theme to use on the client avoids incorrect initial
  // state being displayed.
  if (theme === null) {
    return null
  }

  return (
    <label>
      <label className={styles['dayNight']}>
      <input
        type="checkbox"
        onChange={(e) => toggleTheme(e.target.checked ? 'dark' : 'light')}
        checked={theme === 'dark'}
      />
      <div></div>
      </label>
    </label>
  )
}

export default SiteThemeToggler;